import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormComponent } from '../form/form.component';

@Component({
    selector: 'app-invalid-popup',
    templateUrl: './invalid-popup.component.html',
    styleUrls: ['./invalid-popup.component.css']
})
export class InvalidPopupComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
    ngOnInit(): void {

    }

}
